import { Box, Typography } from '@mui/material';

const MonitoringDashboard = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Monitoring Dashboard
      </Typography>
      {/* Add your monitoring dashboard content here */}
    </Box>
  );
};

export default MonitoringDashboard; 